const locale = "ja-JP";
const translations = {
	timeFormat: "HH:mm",
	dateFormat: "YYYY/MM/DD",
	dateTimeFormat: "YYYY/MM/DD HH:mm",
	"serviceReports.headline": "サービスレポート",
	"serviceReports.sublineMachine": "マシンのサービスレポートを見て、ダウンロードすることができます。",
	"serviceReports.technicianName": "サービスエンジニア名",
	"serviceReports.machineNameAndNumber": "マシン＆マシン番号",
	"serviceReports.startDate": "開始",
	"serviceReports.endDate": "終了",
	"serviceReports.creationDate": "作成日",
	"serviceReports.openReport": "サービスレポートを開く（PDF）",
	"serviceReports.filter": "フィルター",
	"serviceReports.missionNumber": "サービス出動番号",
	"serviceReports.assignmentType": "サービスレポートタイプ",
	"serviceReports.reportTypes.IA": "撤去 / 移動レポート",
	"serviceReports.reportTypes.AC": "アプリケーションコンサルティングレポート",
	"serviceReports.reportTypes.IV": "設置準備レポート",
	"serviceReports.reportTypes.BA": "評価レポート",
	"serviceReports.reportTypes.UV": "安全点検レポート",
	"serviceReports.reportTypes.IG": "中古マシンの設置レポート",
	"serviceReports.reportTypes.UB": "品質対策レポート",
	"serviceReports.reportTypes.PN": "生産支援レポート",
	"serviceReports.reportTypes.NR": "レトロフィットレポート",
	"serviceReports.reportTypes.IB": "設置・スタートアップレポート",
	"serviceReports.reportTypes.II": "設置統合レポート",
	"serviceReports.reportTypes.IC": "内部修理レポート",
	"serviceReports.reportTypes.MB": "見本市サービスレポート",
	"serviceReports.reportTypes.HW": "リソースレポート",
	"serviceReports.reportTypes.TT": "エンジニアトレーニングレポート",
	"serviceReports.reportTypes.SK": "カスタマートレーニングレポート",
	"serviceReports.reportTypes.RP": "修理レポート",
	"serviceReports.reportTypes.RW": "修理・メンテナンスレポート",
	"serviceReports.reportTypes.WA": "メンテナンスレポート",
	"serviceReports.reportTypesPlural.IA": "撤去 / 移動レポート",
	"serviceReports.reportTypesPlural.AC": "アプリケーションコンサルティングレポート",
	"serviceReports.reportTypesPlural.IV": "設置準備レポート",
	"serviceReports.reportTypesPlural.BA": "評価レポート",
	"serviceReports.reportTypesPlural.UV": "安全点検レポート",
	"serviceReports.reportTypesPlural.IG": "中古マシンの設置レポート",
	"serviceReports.reportTypesPlural.UB": "品質対策レポート",
	"serviceReports.reportTypesPlural.PN": "生産支援レポート",
	"serviceReports.reportTypesPlural.NR": "レトロフィットレポート",
	"serviceReports.reportTypesPlural.IB": "設置・スタートアップレポート",
	"serviceReports.reportTypesPlural.II": "設置統合レポート",
	"serviceReports.reportTypesPlural.IC": "内部修理レポート",
	"serviceReports.reportTypesPlural.MB": "見本市サービスレポート",
	"serviceReports.reportTypesPlural.HW": "リソースレポート",
	"serviceReports.reportTypesPlural.TT": "エンジニアトレーニングレポート",
	"serviceReports.reportTypesPlural.SK": "カスタマートレーニングレポート",
	"serviceReports.reportTypesPlural.RP": "修理レポート",
	"serviceReports.reportTypesPlural.RW": "修理・メンテナンスレポート",
	"serviceReports.reportTypesPlural.WA": "メンテナンスレポート",
	"serviceReports.loadMore": "もっと読み込む",
	"serviceReports.loadError": "データをロードする際にエラーが発生しました",
	"serviceReports.noReportsFound": "現在サービスレポートはありません。",
	"serviceReports.noReportsAvailable": "現在サービスレポートはありません。",
	missingAuthorization: "権限なし",
	"headline.createCase": "新規サービス案件の作成",
	"headline.caseDetails": "案件詳細",
	"headline.contactData": "連絡先データ",
	"field.reason.label": "通知理由",
	"field.machine.label": "マシン＆マシン番号",
	"field.softwareProblemClassification.label": "問題の区分",
	"field.softwareInstallationProblem.label": "設置に関する問題",
	"field.softwareLicenseIssue.label": "ライセンスに関する問題",
	"field.softwareType.label": "ソフトウェアタイプ",
	"field.softwareModule.label": "ソフトウェアモジュール",
	"field.errorNumber.label": "エラー番号",
	"field.errorNumber.explanation": "0000FC00、1.10.58102409や6000など",
	"field.errorNumber.addAnotherNumber": "その他のエラー番号を追加する",
	"field.errorNumber.errorMessage": "無効なエラー番号",
	"field.message.label": "メッセージ",
	"field.message.placeholder": "案件・問題を（挨拶文なしで）出来る限り具体的かつ必要な限り詳細に記述してください。 よろしくお願い致します。",
	"field.fileUpload.label": "付録",
	"field.fileUpload.info": "許容ファイル形式：IMG、JPG、PNG、PDF、HTML、TruTopsファイルなど（最大16 MB）およびMP4 動画ファイル（最大50 MB）",
	"field.salutation.label": "呼称",
	"field.salutation.male": "Mr.",
	"field.salutation.female": "Ms.",
	"field.firstName.label": "名",
	"field.lastName.label": "姓",
	"field.email.label": "Eメール",
	"field.phone.label": "電話番号",
	"button.submit": "送信",
	"button.cancel": "キャンセル",
	"button.back": "戻る",
	"button.next": "進む",
	"button.close": "閉じる",
	"button.ok": "OK",
	"auth.error": "予期せぬエラーが発生しました。",
	"select.placeholder": "選択してください…",
	"validation.requiredField": "これは入力必須項目です",
	"validation.invalidEmail": "有効なEメールアドレスを入力してください",
	"validation.maxAllowedCharacters": "最大許容文字数：{{number}}",
	"validation.requiredFieldsExplanation": "必須項目には*が付いています。",
	"validation.invalidPhoneNumber": "有効な電話番号を入力してください。",
	"softwareProblemClassification.standstill": "停止",
	"softwareProblemClassification.fault": "故障",
	"softwareProblemClassification.slightImpairment": "軽度の悪影響",
	"softwareProblemClassification.generalInquiry": "一般的な問い合わせ",
	"serviceCase.proactiveCaseClosure.title": "フィードバック＆案件終了申請",
	"serviceCase.proactiveCaseClosure.instructions": "案件終了を申請するに当たり、フィードバックをぜひお寄せください。当社の予知サービスの改善に活用させて頂きます。",
	"serviceCase.proactiveCaseClosure.question.submit": "送信",
	"serviceCase.proactiveCaseClosure.dialogTitle": "案件終了を申請しました。フィードバックありがとうございました。",
	"serviceCase.proactiveCaseClosure.dialog.buttonOk": "OK",
	"serviceCase.proactiveCaseClosure.question.anomaly": "報告された異常はマシンで発生していましたか？",
	"serviceCase.proactiveCaseClosure.question.technicalGuideLinked": "テクニカルガイドが提供されましたか？",
	"serviceCase.proactiveCaseClosure.question.technicalGuideHelpful": "問題をテクニカルガイドを使用してご自身で解決することができましたか？",
	"serviceCase.proactiveCaseClosure.question.pauseRequest": "この種の異常に関する通知の一時停止をご希望されますか？",
	"serviceCase.proactiveCaseClosure.question.pauseRequestDuration": "この種の異常に関する通知の一時停止をどれくらいの期間ご希望されますか？",
	"serviceCase.proactiveCaseClosure.question.comment": "この種の異常に関する通知の一時停止をご希望される理由を述べてください：",
	"serviceCase.proactiveCaseClosure.question.commentPlaceholder": "このコメントは、案件終了を申請してフィードバックを送信する際に不可欠です",
	"serviceCase.proactiveCaseClosure.answers.yes": "はい",
	"serviceCase.proactiveCaseClosure.answers.no": "いいえ",
	"serviceCase.proactiveCaseClosure.answers.sevenDays": "7日",
	"serviceCase.proactiveCaseClosure.answers.fourteenDays": "14日",
	"serviceCase.proactiveCaseClosure.answers.thirtyDays": "30日",
	"serviceCase.proactiveCaseClosure.answers.ninetyDays": "90日",
	"sisConnector.success.headline": "サービス案件が作成されました。",
	"sisConnector.success.orderNumberRequired.title": "注記：",
	"sisConnector.success.orderNumberRequired.text": "案件詳細ページで、案件の請求およびその他のサービスの注文番号を追加してください。",
	"sisConnector.success.technicalGuide.title": "このエラー番号ではテクニカルガイドが利用可能です。",
	"sisConnector.success.technicalGuide.text": "入力したエラー番号に基づいて、1つまたは複数のテクニカルガイドを見つけることができました。案件の約50%では、これで問題を自分で解決することができます。この機能は、これに対応する保守契約がなければ利用できません。",
	"sisConnector.success.outsideOfServiceHours": "当社のサービス時間外に作成された案件は処理されないことにご注意ください。",
	"sisConnector.success.serviceTimes.MonFri": "当社のサービス時間：月曜日～金曜日",
	"sisConnector.success.serviceTimes.Sat": "および土曜日",
	"sisConnector.success.withTechnicalServiceHotline": "即座に支援が必要な場合は、TRUMPF技術サービス（{{hotline}}）に電話して、サポートを受けてください。",
	"sisConnector.success.withoutTechnicalServiceHotline": "即座に支援が必要な場合は、TRUMPF技術サービスに電話して、サポートを受けてください。",
	"sisConnector.success.caseId": "案件番号",
	"sisConnector.failed.headline": "サービス案件を作成できませんでした。",
	"sisConnector.failed.unknownError": "もう一度お試しになるか、サポート係にお問い合わせください。"
};
var jaJP = {
	locale: locale,
	translations: translations
};

export { jaJP as default, locale, translations };
//# sourceMappingURL=ja-JP-CPkacn2p.js.map

//# sourceMappingURL=ja-JP-CPkacn2p.js.map